// 상대경로를 절대경로로 변환 (로컬 개발환경에서 프론트/백엔드 포트가 다를 때 대비)
// 운영환경(nginx가 같은 도메인으로 프록시)에서는 그대로 상대경로 반환되어 문제없음
export const resolveImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:')) return url; // 이미 절대경로 또는 Base64
  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  const apiOrigin = apiUrl.startsWith('http') ? new URL(apiUrl).origin : '';
  return `${apiOrigin}${url}`;
};